import { ActionReducer, Action } from "@ngrx/store"
import { EventsStore } from "@store/events"

import { TicketAllocation } from "@models/ticket-allocation"

export const eventsReducer: ActionReducer<EventsStore> = (state: EventsStore = new EventsStore(), action: Action) => {
  const s = EventsStore.clone(state)
  let activeEvent
  let allocation
  let allocationIndex
  let ticket
  let ticketIndex
  let newAllocations
  let newTickets
  let newActiveEvent

  switch(action.type) {
    case POPULATE_EVENTS:
      return {
        ...s,
        events: action.payload,
      }

    case ADD_EVENT:
      return {
        ...s,
        events: [
          ...state.events,
          action.payload,
        ]
      }

    case POPULATE_ACTIVE_EVENT:
      return {
        ...s,
        activeEvent: action.payload,
      }

    case POPULATE_EDITABLE_CREDIT_CARD:
      return {
        ...s,
        editableCreditCard: action.payload,
      }

    case PURCHASE_TICKETS_AS_GUEST:
      return {
        ...s,
        loading: true,
      }

    case PURCHASED_TICKETS_AS_GUEST:
      return {
        ...s,
        loading: false,
      }

    case PURCHASE_TICKETS_AS_GUEST_FAILURE:
      return {
        ...s,
        errors: action.payload,
        loading: false,
      }

     case PURCHASE_TICKETS_AS_EXISTING:
       return {
         ...s,
         loading: true,
       }

     case PURCHASED_TICKETS_AS_EXISTING:
       return {
         ...s,
         loading: false,
       }

     case PURCHASE_TICKETS_AS_EXISTING_FAILURE:
       return {
         ...s,
         errors: action.payload,
         loading: false,
       }

    case PURCHASE_TICKET_AS_STAFF:
      return {
        ...s,
        loading: true,
      }

    case PURCHASED_TICKET_AS_STAFF:
      return {
        ...s,
        loading: false,
      }

    case PURCHASE_TICKET_AS_STAFF_FAILURE:
      return {
        ...s,
        errors: action.payload,
        loading: false,
      }

       // TODO: Test coverage on these items
       // TODO: Introduce immutable.js
      case DELETE_TICKET_FROM_EVENT:
        activeEvent = { ...s.activeEvent }
        allocationIndex = activeEvent.ticketAllocations.findIndex((ta) => {
          return action.payload.allocation.id === ta.id;
        })
        allocation = TicketAllocation.clone(action.payload.allocation)
        ticket = { ...action.payload.ticket }

        newTickets = activeEvent.ticketAllocations[allocationIndex].tickets.map((t) => {
          if (t.id === ticket.id) {
            return {
              ...t,
              uiState: {
                failure: false,
                loading: true,
              },
            }
          }

          return {
            ...t,
          }
        })

        newAllocations = activeEvent.ticketAllocations.map((ta) => {
          if (ta.id === allocation.id) {
            return {
              ...ta,
              tickets: newTickets,
            }
          }

          return {
            ...ta,
          }
        })

        return {
          ...s,
          activeEvent: {
            ...activeEvent,
            ticketAllocations: newAllocations,
          },
        }
      case DELETED_TICKET_FROM_EVENT:
        activeEvent = { ...s.activeEvent }
        allocationIndex = activeEvent.ticketAllocations.findIndex((ta) => {
          return action.payload.allocation.id === ta.id;
        })
        allocation = TicketAllocation.clone(action.payload.allocation)
        ticket = { ...action.payload.ticket }

        newTickets = activeEvent.ticketAllocations[allocationIndex].tickets.filter((t) => {
          return t.id != ticket.id
        })

        newAllocations = activeEvent.ticketAllocations.map((ta) => {
          if (ta.id === allocation.id) {
            return {
              ...ta,
              tickets: newTickets,
            }
          }

          return {
            ...ta,
          }
        })

        return {
          ...s,
          activeEvent: {
            ...activeEvent,
            ticketAllocations: newAllocations,
          },
        }
      case DELETE_TICKET_FROM_EVENT_FAILURE:
        activeEvent = { ...s.activeEvent }
        allocationIndex = activeEvent.ticketAllocations.findIndex((ta) => {
          return action.payload.allocation.id === ta.id;
        })
        allocation = TicketAllocation.clone(action.payload.allocation)
        ticket = { ...action.payload.ticket }

        newTickets = activeEvent.ticketAllocations[allocationIndex].tickets.map((t) => {
          if (t.id === ticket.id) {
            return {
              ...t,
              uiState: {
                failure: true,
                loading: false,
              },
            }
          }

          return {
            ...t,
          }
        })

        newAllocations = activeEvent.ticketAllocations.map((ta) => {
          if (ta.id === allocation.id) {
            return {
              ...ta,
              tickets: newTickets,
            }
          }

          return {
            ...ta,
          }
        })

        return {
          ...s,
          activeEvent: {
            ...activeEvent,
            ticketAllocations: newAllocations,
          },
        }
    case CLEAR_EVENT_ERRORS:
      return {
        ...s,
        loading: false,
        errors: null,
      }

    default:
      return state

  }
}

export const FETCH_EVENTS = "FETCH_EVENTS"
export const FETCH_EVENTS_FAILURE = "FETCH_EVENTS_FAILURE"
export const POPULATE_EVENTS = "POPULATE_EVENTS"
export const FETCH_EVENT = "FETCH_EVENT"
export const FETCH_EVENT_FAILURE = "FETCH_EVENT_FAILURE"
export const POPULATE_ACTIVE_EVENT = "POPULATE_ACTIVE_EVENT"
export const ADD_EVENT = "ADD_EVENT"
export const CREATE_EVENT = "CREATE_EVENT"
export const CREATED_EVENT = "CREATED_EVENT"
export const CREATE_EVENT_FAILURE = "CREATE_EVENT_FAILURE"
export const UPDATE_EVENT = "UPDATE_EVENT"
export const UPDATED_EVENT = "UPDATED_EVENT"
export const UPDATE_EVENT_FAILURE = "UPDATE_EVENT_FAILURE"
export const DELETE_TICKET_FROM_EVENT = "DELETE_TICKET_FROM_EVENT"
export const DELETED_TICKET_FROM_EVENT = "DELETED_TICKET_FROM_EVENT"
export const DELETE_TICKET_FROM_EVENT_FAILURE = "DELETE_TICKET_FROM_EVENT_FAILURE"
export const POPULATE_EDITABLE_CREDIT_CARD = "POPULATE_EDITABLE_CREDIT_CARD"
export const PURCHASE_TICKETS_AS_GUEST = "PURCHASE_TICKETS_AS_GUEST"
export const PURCHASED_TICKETS_AS_GUEST = "PURCHASED_TICKETS_AS_GUEST"
export const PURCHASE_TICKETS_AS_GUEST_FAILURE = "PURCHASE_TICKETS_AS_GUEST_FAILURE"
export const PURCHASE_TICKETS_AS_EXISTING = "PURCHASE_TICKETS_AS_EXISTING"
export const PURCHASED_TICKETS_AS_EXISTING = "PURCHASED_TICKETS_AS_EXISTING"
export const PURCHASE_TICKETS_AS_EXISTING_FAILURE = "PURCHASE_TICKETS_AS_EXISTING_FAILURE"
export const PURCHASE_TICKET_AS_STAFF = "PURCHASE_TICKET_AS_STAFF"
export const PURCHASED_TICKET_AS_STAFF = "PURCHASED_TICKET_AS_STAFF"
export const PURCHASE_TICKET_AS_STAFF_FAILURE = "PURCHASE_TICKET_AS_STAFF_FAILURE"
export const CLEAR_EVENT_ERRORS = "CLEAR_EVENT_ERRORS"



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/reducers/events.ts